import React from 'react'
import MUIStepper, { StepperProps as MUIStepperProps } from '@mui/material/Stepper';
import MUIStep, { StepProps as MUIStepProps } from '@mui/material/Step';
import MUIStepLabel, { StepLabelProps as MUIStepLabelProps } from '@mui/material/StepLabel';
import MUIStepContent, { StepContentProps as MUIStepContentProps } from '@mui/material/StepContent';

export type StepProps = MUIStepProps

export const Step: React.FC<StepProps> = (props) => {
  return (
    <MUIStep {...props} />
  )
}

export type StepLabelProps = MUIStepLabelProps

export const StepLabel: React.FC<StepLabelProps> = (props) => {
  return (
    <MUIStepLabel {...props} />
  )
}

export type StepContentProps = MUIStepContentProps

export const StepContent: React.FC<StepContentProps> = (props) => {
  return (
    <MUIStepContent {...props} />
  )
}

export type StepperProps = MUIStepperProps

const Stepper: React.FC<StepperProps> = (props) => {
  return (
    <MUIStepper {...props} />
  )
}

export default Stepper
